import { createStore, applyMiddleware } from 'redux';

export default function createStores (reducers, middlewares) {
  const enhancer = applyMiddleware(...middlewares);

  return createStore(reducers, enhancer);
};
